import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-half-arrow",
  "use": "icon-right-half-arrow-usage",
  "viewBox": "0 0 25 8",
  "content": "<symbol viewBox=\"0 0 25 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-half-arrow\">\r\n<path d=\"M1 7H23.68L17 1\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol